import {
  resetPartnerPassword,
  resetWFHPassword,
  updateWFHUserDetails,
  updateConfigureNotifications,
} from './sessionHelper';

export async function partnerIndexActions(store, { request }) {
  const { dispatch } = store;
  const formData = await request.formData();
  const intent = formData.get('intent');

  let result = { success: false, error: null };
  switch (intent) {
    case 'reset-partner-password':
      result = await resetPartnerPassword(dispatch, formData);
      break;
    case 'update-login-details':
      result = await updateWFHUserDetails(dispatch, formData);
      break;
    case 'update-notification-configuration':
      result = await updateConfigureNotifications(dispatch, formData);
      break;
    default:
      break;
  }

  return result;
}

export async function wfhIndexActions(store, { request }) {
  const { dispatch, getState } = store;
  const formData = await request.formData();
  const intent = formData.get('intent');

  let result = { success: false, error: null };
  switch (intent) {
    case 'reset-user-password':
      result = await resetWFHPassword(dispatch, getState, formData);

      break;
    default:
      break;
  }

  return result;
}
